<template>
    <div>
        <div class="mask" v-show="visible" @click="close"></div>
        <div class="dialog" v-show="visible">
            <div class="dialog-body">
                <img src="./../assets/2024/share-dialog-icon.png" alt="关注“中国反邪教”公众号">
            </div>
            <div class="dialog-footer">
                <button @click="close">关闭</button>
            </div>
        </div>
    </div>
</template>
<script>
/*
* 关注公众号dialog
*/
export default {
    name: 'FollowAccount',
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            visible: false,
        }
    },
    watch: {
        show: {
            handler(newValue, oldValue) {
                console.log(newValue, oldValue)
                if (newValue) {
                    this.val = ''
                    document.body.classList.add('no-scroll')
                } else {
                    document.body.classList.remove('no-scroll')
                }
                this.visible = newValue
            },
            deep: true,
        }
    },
    mounted() {
        this.visible = this.show
    },
    methods: {
        close() {
            this.visible = false
            this.$emit('close')
        },
    }
}
</script>
<style lang="scss" scoped>
.mask {
    animation-duration: 0.3s;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);
}
.dialog {
    position: fixed;
    max-height: 100%;
    overflow-y: auto;
    transition: transform .3s;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .dialog-body {
        margin: 0 15px;
        img {
            width: 70vw;
        }
    }
    .dialog-footer {
        margin-top: 30px;
        button {
            color: #fff;
            background: transparent;
            border-radius: 50px;
            border: 1px solid #fff;
            width: 130px;
            padding: 10px;
            display: inline-block;
            font-size: 16px;
            font-family: PingFangSC-Medium;
            color: #FFFFFF;
            font-weight: 500;
        }
    }
}
</style>
  